module.exports = __webpack_public_path__ + "static/Setup-2-c2e939caf50dc5ad502523289b7b1245.png";